import React from 'react'

import { List, useMediaQueryContext } from '@fourthwall/components'
import type { DnsRecord } from '@fourthwall/services/dist/DnsApiClient'

import { getErrorTooltipText } from '../../utils/getErrorTooltipText'
import { getTableHeaders } from '../../utils/getTableHeaders'
import { DnsRecordListItem } from '../DnsRecordListItem/DnsRecordListItem'
import * as S from './DnsRecordsData.styled'

type DnsRecordsTableProps = {
  records: DnsRecord[]
  isVerificationInProgress: boolean
}

export const DnsRecordsData = ({ records, isVerificationInProgress }: DnsRecordsTableProps) => {
  const media = useMediaQueryContext()

  if (!media.tablet) {
    return (
      <List
        data={records}
        renderItem={(record: DnsRecord) => <DnsRecordListItem record={record} />}
      />
    )
  }

  const tableHeaders = getTableHeaders(isVerificationInProgress)

  const renderData = () =>
    records.map((record, index) => (
      <S.Row key={index}>
        <S.Content>
          {tableHeaders.map(({ id, render, width, alignment }) => (
            <S.Cell key={`${id}${index}`} flex={width} alignment={alignment}>
              {render(record, index)}
            </S.Cell>
          ))}
        </S.Content>
        {record.lookupValidationError && <S.Error>{getErrorTooltipText(record)}</S.Error>}
      </S.Row>
    ))

  return (
    <S.TableContainer>
      <S.Headers>
        {tableHeaders.map(({ id, width, alignment, label }) => (
          <S.HeadCell key={id} id={id} flex={width} alignment={alignment}>
            {label}
          </S.HeadCell>
        ))}
      </S.Headers>
      {renderData()}
    </S.TableContainer>
  )
}
